export const VECTOR_TILE_SIGNATURE_EXPIRED = 'VECTOR_TILE_SIGNATURE_EXPIRED';
export const VECTOR_TILE_SIGNATURE_INVALID = 'VECTOR_TILE_SIGNATURE_INVALID';

export function isVectorTileSignatureExpiredError(
  body: Record<string, unknown> | undefined,
): boolean {
  return body?.error === VECTOR_TILE_SIGNATURE_EXPIRED;
}
